import { compose, filter, keys, pickBy, values } from 'ramda'
import React from 'react'
import tinyColor from 'tinycolor2'

import { ThemeContext } from '../ThemeHandler'

export const useColors = () => React.useContext(ThemeContext)?.colors

export const useGetColor = () => {
  const colors = useColors()
  return (color, defaultColor) => colors[color || defaultColor] || color || defaultColor
}

export const useColor = (color, defaultColor) => {
  const getColor = useGetColor()
  return getColor(color, defaultColor)
}

export const useTinyColor = (color, defaultColor) => {
  return tinyColor(useColor(color, defaultColor))
}

export const useContrastColor = (color, defaultColor) => {
  const colors = useColors()
  const tColor = useTinyColor(color, defaultColor)
  return tinyColor.mostReadable(tColor, [colors.white, colors.dark1]).toHexString()
}

export const useSelectableColors = () => {
  return compose(
    filter(color => !['black', 'white', 'dark1', 'dark2', 'light1', 'light2', 'primary'].includes(color)), //
    keys
  )(useColors())
}

export const useColorfullColors = () => {
  return compose(
    values,
    pickBy(
      (_, color) =>
        ![
          'primary',
          'black',
          'white',
          'dark1',
          'dark2',
          'dark3',
          'dark4',
          'light1',
          'light2',
          'light3',
          'light4',
          'light5'
        ].includes(color)
    )
  )(useColors())
}

export const useColorById = id => {
  const colors = useColorfullColors()
  if (!id) return null

  const size = colors.length
  const index = id % size
  return colors[index]
}
